<template>
  <HeroView
      title="Megastore"
      text="Multipurpose theme for any catalog size — with conversion tools, modern design, and sales-focused merchandising features."
      purchase-link="https://themes.shopify.com/themes/megastore/presets/megastore"
      price="$380"
      img-main="/assets/imgs/themes/megastore/hero/hero@2x.webp"
      img-set="/assets/imgs/themes/megastore/hero/hero.webp 1x, /assets/imgs/themes/megastore/hero/hero@2x.webp 2x"
      img-alt="Megastore theme hero header design for large catalogs"
  />

  <DemosView
      title="5 Sales-Optimized <br>Pre-Designed Presets"
      text="Explore 5 powerful presets—built to boost sales and deliver results with proven layouts and features."
      theme-id="megastore"
  />
  <BannerView
      title="Create a Store That’s a Sales Engine in Every Pixel"
      text="Every section and detail is designed to sell more — from advanced filtering and promo blocks to a minimalist modular layout with structured grids and modern typography."
      purchase-link="https://themes.shopify.com/themes/megastore/presets/megastore"
      price="$380"
      img-main="/assets/imgs/themes/megastore/banner@2x.webp"
      img-set="/assets/imgs/themes/megastore/banner.webp 1x, /assets/imgs/themes/megastore/banner@2x.webp 2x"
      img-alt="Promotional marketing banner for Megastore Shopify theme"
  />
  <FeaturesView/>
  <BuiltView/>
  <DocView
      doc-link="/help-center/documentation/megastore/"
      img-main="/assets/imgs/themes/megastore/doc/doc@2x.webp"
      img-set="/assets/imgs/themes/megastore/doc/doc.webp 1x, /assets/imgs/themes/megastore/doc/doc@2x.webp 2x"
      img-alt="Megastore Shopify theme technical documentation guide"
  />
  <FinalView
      title="Launch with a Theme That Converts"
      text="Everything in this theme is optimized to help you convert more, boost&nbsp;revenue, and grow faster."
      purchase-link="https://themes.shopify.com/themes/megastore/presets/megastore"
      price="$380"
      img-main="/assets/imgs/themes/megastore/final@2x.webp"
      img-set="/assets/imgs/themes/megastore/final.webp 1x, /assets/imgs/themes/megastore/final@2x.webp 2x"
      img-alt="Megastore Shopify theme final checkout and UI design"
  />
</template>

<script>
import HeroView from '@/components/general/HeroView.vue'
import DemosView from '@/components/general/DemosView.vue'
import BannerView from '@/components/general/BannerView.vue'
import FeaturesView from '@/components/general/FeaturesView.vue'
import BuiltView from '@/components/general/BuiltView.vue'
import DocView from '@/components/general/DocView.vue'
import FinalView from '@/components/general/FinalView.vue'

export default {
  name: 'MegastoreView',
  components: {
    HeroView,
    DemosView,
    BannerView,
    FeaturesView,
    BuiltView,
    DocView,
    FinalView
  }
}
</script>

<script setup>
import { useHead } from '@vueuse/head'

useHead({
  title: 'Megastore – Multipurpose & Feature‑Rich Shopify Theme',
  meta: [
    { name: 'description', content: 'Megastore is a multipurpose Shopify theme for any catalog size, featuring conversion tools, modern design, and sales-focused merchandising features.' },

    { property: 'og:title', content: 'Megastore – Multipurpose & Functional Shopify Theme' },
    { property: 'og:description', content: 'Multipurpose Shopify theme with powerful conversion tools and structured design. Features quick add, mega menu, and promo banner combinations.' },
    { property: 'og:image', content: '/assets/imgs/themes/megastore/og_image.png' },
    { property: 'og:url', content: 'https://creativecommercelabs.com/themes/megastore' },
    { property: 'og:type', content: 'website' },
    { property: 'og:locale', content: 'en_US' },
    { property: 'og:site_name', content: 'Megastore' }
  ]
})
</script>
